import React from 'react';
import styled, { css } from 'styled-components/native';
import Controller from '../../../screens/landing/Home/components/Controller';

interface IProps {
  leftControllerName: string;
  rightControllerName: string;
  activeTab: string;
  onSwitchActiveTab: (tab: string) => void;
  disabledRight?: boolean;
}

const Controllers: React.FC<IProps> = (props) => {
  const { leftControllerName, rightControllerName, activeTab, onSwitchActiveTab, disabledRight } = props;

  return (
    <S.ControllersContainer>
      <S.LeftController
        onPress={() => onSwitchActiveTab(leftControllerName)}
        content={leftControllerName}
        isActive={activeTab === leftControllerName}
      />
      <S.RightController
        onPress={() => onSwitchActiveTab(rightControllerName)}
        content={rightControllerName}
        isActive={activeTab === rightControllerName}
        disabled={!!disabledRight}
      />
    </S.ControllersContainer>
  );
};

const S = {
  ControllersContainer: styled.View`
    display: flex;
    flex-direction: row;
    padding-bottom: 10px;
  `,
  LeftController: styled(Controller)`
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    margin-right: 4px;
    ${({ theme }) => css`
      font-size: ${theme.fontSizes.s22}px;
    `};
  `,
  RightController: styled(Controller)<{ disabled: boolean }>`
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    ${({ theme, disabled }) => css`
      font-size: ${theme.fontSizes.s22}px;
      background-color: ${disabled ? theme.colors.lightGray1 : theme.colors.white};
      border-color: ${theme.colors.white};
      border-width: 1px;
    `};
  `,
};

export default Controllers;
